// bottom-pane.ref.ts (corrigé)
import { OverlayRef } from '@angular/cdk/overlay';
import { signal } from '@angular/core';
import { Subject } from 'rxjs';
import { BottomPaneState } from './bottom-pane.tokens';

export class BottomPaneRef<TResult = unknown> {
  private readonly _afterClosed = new Subject<TResult | undefined>();
  private readonly _beforeClosed = new Subject<TResult | undefined>();

  private readonly _isOpen = signal(true);
  private readonly _height = signal<number>(null);
  private readonly _minimized = signal(false);
  private readonly _dragging = signal(false);

  readonly title = signal<string>('');
  readonly subTitle = signal<string>('');

  readonly state: BottomPaneState = {
    isOpen: this._isOpen.asReadonly(),
    height: this._height.asReadonly(),
    minimized: this._minimized.asReadonly(),
    dragging: this._dragging.asReadonly(),
  };
  componentInstance: any;

  constructor(
    public readonly id: string,
    private readonly overlayRef: OverlayRef,
  ) {
    this.overlayRef.detachments().subscribe(() => {
      if (this._isOpen()) {
        this._isOpen.set(false);
        this._beforeClosed.complete();
        this._afterClosed.complete();
      }
    });
  }

  afterClosed$() {
    return this._afterClosed.asObservable();
  }

  beforeClosed$() {
    return this._beforeClosed.asObservable();
  }

  closeClick(result?: TResult) {
    if (!this._isOpen()) return;   
    this._beforeClosed.next(result);
    this._beforeClosed.complete();
    this._isOpen.set(false);
    // add closing animation
    const el = this.overlayRef.overlayElement.querySelector('.bp-shell');
    const backdropElement: HTMLElement = this.overlayRef.backdropElement!;    
    backdropElement.classList.add('tt-backdrop-hidden');
    backdropElement.classList.add('tt-backdrop-none');
    if (!el) {
      this.finishClose(result);
      return;
    }
    const onEnd = () => {
      el.removeEventListener('animationend', onEnd);
      this.finishClose(result);
    };
    el.addEventListener('animationend', onEnd);
    el.classList.add('closing');
  }

  private finishClose(result?: TResult) {
    this.overlayRef.dispose();

    this._afterClosed.next(result);
    this._afterClosed.complete();
  }

  close(result?: TResult) {
    this._beforeClosed.next(result);
    this._beforeClosed.complete();
    if (!this._isOpen()) return;
    this._isOpen.set(false);
    // const el = this.overlayRef.overlayElement.querySelector('.bp-shell');
    // const backdropElement: HTMLElement = this.overlayRef.backdropElement!;
    // backdropElement.classList.add('tt-backdrop-hidden');
    // backdropElement.classList.add('tt-backdrop-none');
    // if (!el) {
    //   this.finishClose(result);
    //   return;
    // }
    // const onEnd = () => {
    //   console.log('ooon end');
      
    //   el.removeEventListener('animationend', onEnd);
    //   this.finishClose(result);
    // };
    // el.addEventListener('animationend', onEnd);
    // el.classList.add('closing');

    this.overlayRef.dispose();
    this._afterClosed.next(result);
    this._afterClosed.complete();
  }

  getOverlayRef(): OverlayRef {
    return this.overlayRef;
  }

  setZIndex(z: number) {
    this.overlayRef.hostElement.style.zIndex = String(z);
  }

  bringToFront(maxZIndexInUse: number) {
    this.setZIndex(maxZIndexInUse + 1);
  }

  updateHeight(heigth: number) {
    this._height.set(heigth);
    const el = this.overlayRef.overlayElement as HTMLElement;
    el.style.height = `${heigth}vh`;
  }

  minimize(min = true) {
    this._minimized.set(min);
  }
}